import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../strings/AuQuotidien';
import './AuQuotidienScreen.css';

async function openUrl(url: string) {
  try {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url, presentationStyle: 'popover' });
  } catch {
    window.open(url, '_blank', 'noopener');
  }
}

function SectionLabel({ icon, title }: { icon: string; title: string }) {
  return (
    <div className="aq-section-label">
      <span>{icon}</span>
      <span>{title}</span>
    </div>
  );
}

export function AuQuotidienScreen() {
  const navigate = useNavigate();

  return (
    <div className="aq-screen">
      <div className="aq-header">
        <button className="aq-header-back" onClick={() => window.history.length > 1 ? navigate(-1) : navigate('/')}>‹</button>
        <div>
          <h1>{t.screenTitle}</h1>
          <p className="aq-header-sub">{t.screenSub}</p>
        </div>
      </div>

      <div className="aq-body">

        {/* ── Services publics ────────────────────────────── */}
        <div>
          <SectionLabel icon="🏛" title={t.services.title} />
          <div className="aq-services-grid">
            {t.services.items.map((item) => (
              <button
                key={item.id}
                className="aq-service-tile"
                onClick={() => openUrl(item.url)}
              >
                <span className="aq-service-icon">{item.icon}</span>
                <span className="aq-service-label">{item.label}</span>
                <span className="aq-service-sub">{item.sub}</span>
              </button>
            ))}
          </div>
        </div>

        {/* ── Transports ─────────────────────────────────── */}
        <div>
          <SectionLabel icon="🚌" title={t.transports.title} />
          <div className="aq-transport-list">
            {t.transports.items.map((item) => (
              <div
                key={item.id}
                className="aq-transport-row"
                onClick={() => openUrl(item.url)}
                role="button"
              >
                <span className="aq-transport-icon">{item.icon}</span>
                <div className="aq-transport-body">
                  <p className="aq-transport-label">{item.label}</p>
                  <p className="aq-transport-sub">{item.sub}</p>
                </div>
                <span className="aq-transport-arrow">›</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── Urgences ────────────────────────────────────── */}
        <div>
          <SectionLabel icon="🆘" title={t.urgences.title} />
          <p className="aq-urgences-disclaimer">{t.urgences.disclaimer}</p>

          {/* Numéros courts — grille 3 colonnes, sauf 114 sur 2 cols */}
          <div className="aq-urgences-highlight-grid">
            {t.urgences.highlighted.slice(0, 3).map((u) => (
              <a key={u.id} className="aq-urgence-tile" href={`tel:${u.tel}`}>
                <span className="aq-urgence-number">{u.number}</span>
                <span className="aq-urgence-label">{u.label}</span>
              </a>
            ))}
            <a className="aq-urgence-tile" href={`tel:${t.urgences.highlighted[3].tel}`}>
              <span className="aq-urgence-number">{t.urgences.highlighted[3].number}</span>
              <span className="aq-urgence-label">{t.urgences.highlighted[3].label}</span>
            </a>
            <a className="aq-urgence-tile aq-urgence-tile-wide" href={`tel:${t.urgences.highlighted[4].tel}`}>
              <span className="aq-urgence-number">{t.urgences.highlighted[4].number}</span>
              <span className="aq-urgence-label">{t.urgences.highlighted[4].label}</span>
            </a>
          </div>

          {/* Numéros longs */}
          <div className="aq-urgences-others">
            {t.urgences.others.map((u) => (
              <a key={u.id} className="aq-urgence-row" href={`tel:${u.tel}`}>
                <span className="aq-urgence-row-label">{u.label}</span>
                <span className="aq-urgence-row-number">{u.display}</span>
              </a>
            ))}
          </div>
        </div>

        {/* ── Infos institutionnelles ─────────────────────── */}
        <div>
          <SectionLabel icon="🏢" title={t.institutions.title} />
          <div className="aq-institution-list">
            {t.institutions.items.map((item) => (
              <div
                key={item.id}
                className="aq-institution-row"
                onClick={() => openUrl(item.url)}
                role="button"
              >
                <span className="aq-institution-icon">{item.icon}</span>
                <div className="aq-institution-body">
                  <p className="aq-institution-label">{item.label}</p>
                  <p className="aq-institution-sub">{item.sub}</p>
                </div>
                <span className="aq-institution-arrow">›</span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}
